import React, { useEffect, useState, createRef, useRef } from 'react';
import { Button } from 'reactstrap';
import { faAngleLeft, faFilePdf, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import downloadBase64File from '../../helpers/downloadFile';


//Helpers
import mascaras from '../../helpers/mascaras';
import { showMessage } from '../../helpers/message';

//API
import requerimento_api from '../../api/requerimento';

//Context
import { useAuth } from '../../context/auth';

//Components
import FichaDocumento from '../AmbienteMunicipe/Requerimento/Components/FichaDocumento';
import MainCard from '../../components/MainCard';
import AcoesRealizadas from './Components/AcoesRealizadas';
import AcaoAtual from './Components/AcaoAtual';
import AcoesAnexos from './Components/AcoesAnexos';

function initialStateAcao() {
  return {
    requerimento_Id: "",
    tipoRequerimentoEtapaAcao_Id: "",
    tipoRequerimentoEtapaProximaAcao_Id: "",
    acaoRealizada: "",
    identificacaoEtapa: "",
    usuario_Id: "",
    observacoes: "",
    dataHora: "",
    nomeUsuario: "",
    responsavel: "",
    dataAgendamento: "",
    formulario: {
      RequerimentoAcaoFormularioResposta: []
    },
    documentos: []
  }
}

function FichaRequerimento({ requerimentoId, btnVoltar = null, requerimentoFicha, editavel = true }) {

  //Estado que guarda os dados do requerimento
  const [requerimento, setRequerimento] = useState({});

  //Estado de controle de exibição do conteudo do documento
  const [documento, setDocumento] = useState(null);

  //Estado de controle da lista de documentos da etapa atual
  const [documentos, setDocumentos] = useState([]);

  //Estado de controle de exibição 
  const [showDivs, setShowDivs] = useState(false);

  //referencia da div do documento
  const ref = useRef(null);

  //referencia da div da ficha
  const refFicha = useRef(null);

  //Estilo da pagina de impressão
  const pageStyle = `
  @page { 
    size: A4;  
    padding: 0.5rem ;
  } 
  @media print { 
      body { -webkit-print-color-adjust: exact; } 
  }
  @media print {
    @page{
      size:A4;
      margin:0.5rem;
    }
    .mainContainerFicha {
      width: 100%!important;
      display:flex;
      flex-direction:column;
    }
    div.header{
      display:table-header-group;
    }
    div.body{
      display:table-row-group;
    }


  }
 `;

  const handlePrint = useReactToPrint({
    content: () => ref.current,
    copyStyles: true,
    documentTitle: documento ? documento.identificacao : "",
    pageStyle: pageStyle
  });
  const handlePrintFicha = useReactToPrint({
    content: () => refFicha.current,
    copyStyles: true,
    documentTitle: documento ? documento.identificacao : "",
    pageStyle: pageStyle,
    onAfterPrint: () => {
      setShowDivs(false);
    }
  });
  //Estado para loading
  const { setLoading, setShowNavigation, session } = useAuth();

  //Função para baixa arquivo
  function handleDownloadFile(fileData, fileName) {
    downloadBase64File(fileData, fileName);
  }



  //Função que carrega o requerimento
  const loadRequerimento = () => {
    setLoading(true);
    requerimento_api.getItem(requerimentoId).then(response => {
      let _documentos = response.data.etapaAtual.documentos ? response.data.etapaAtual.documentos : [];
      _documentos = _documentos.map(value => {
        value.ref = createRef(null);
        value.toolTip = false;
        return value;
      })
      setDocumentos(_documentos);
      setRequerimento(response.data);
    }).catch(e => showMessage("Erro", e.message, "error", null))
      .finally(f => setLoading(false))
  }

  useEffect(() => {
    if (!requerimentoFicha) {
      loadRequerimento();
    } else {
      setRequerimento(requerimentoFicha);
    }
  }, []);

  if (documento)
    return <>
      <div className='mt-4 d-flex align-items-center justify-content-between'>
        <Button onClick={() => {
          setShowNavigation(true);
          setDocumento(null)
        }}><FontAwesomeIcon icon={faAngleLeft} /> Voltar</Button>
        <Button onClick={handlePrint} color='danger'><FontAwesomeIcon icon={faFilePdf} /> Gerar PDF</Button>
      </div>
      <MainCard>
        <div ref={ref}>
          <FichaDocumento documento={documento} />
        </div>
      </MainCard>
    </>

  return (
    <>
      <div className='d-flex align-items-center justify-content-between'>
        {btnVoltar && <Button onClick={btnVoltar}><FontAwesomeIcon icon={faAngleLeft} /> Voltar</Button>}
        {btnVoltar && <Button color='danger' onClick={() => {
          setShowDivs(true);
          setTimeout(() => {
            handlePrintFicha();
          }, 500);
        }}><FontAwesomeIcon icon={faFilePdf} /> Imprimir</Button >}
      </div>
      <MainCard noShadow={!btnVoltar}>
        <div ref={refFicha} className=' mainContainerFicha w-100 p-3'>
          <div className="print m-2 d-flex align-items-center justify-content-between">
            <p>Emitido por:{session.nome}</p>
            <p>Data de emissão: {moment().format("DD/MM/YYYY")}</p>
          </div>

          <div className='header d-flex justify-content-center align-items-start flex-column mb-3'>
            <h2>{requerimento?.identificacaoTipoRequerimento ?? ""}</h2>
            <span className='fw-regular'>Número do requerimento:  <span style={{ color: "#666" }}>{requerimento?.numeroRequerimento}</span></span>
            <span className='fw-regular'>Data do requerimento:  <span style={{ color: "#666" }}>{moment(requerimento.dataRequerimento).format('DD/MM/YYYY')}</span></span>
          </div>

          <div className='body'>
            <div className='row pb-2 shadowFicha rounded-1 mb-4'>
              <h5 className='py-2 titleFicha'>Dados do requerente</h5>
              <div className='col-md-12 col-lg-6 mb-2'>
                <span className="fw-bold" >Documento: </span> {requerimento?.requerente?.documentoPessoal ? requerimento?.requerente?.documentoPessoal : ""}
              </div>
              <div className='col-md-12 col-lg-6 mb-2'>
                <span className="fw-bold">Nome / Razão social: </span> {requerimento?.requerente?.nome ?? ""}
              </div>
              <div className='col-md-12 col-lg-6 mb-2'>
                <span className="fw-bold">Telefone: </span> {mascaras.celularMask(requerimento?.requerente?.telefone ?? "")}
              </div>

              <div className='col-md-12 col-lg-6 mb-2'>
                <span className="fw-bold">Email: </span> {requerimento?.requerente?.email ?? ""}
              </div>
              <div className='col-md-12 col-lg-12 mb-2'>
                <span className="fw-bold">Endereço: </span> {requerimento?.requerente?.logradouro ?? ""}, {requerimento?.requerente?.numero ?? ""}, {requerimento?.requerente?.complemento ? requerimento?.requerente?.complemento + ", " : ""}{requerimento?.requerente?.bairro ?? ""}, {requerimento?.requerente?.cidade ?? ""}, {requerimento?.requerente?.cep ?? ""}, {requerimento?.requerente?.uf ?? ""}
              </div>
            </div>
            <div className='row pb-2 shadowFicha rounded-1 mb-4'>
              <h5 className='py-2 titleFicha'>Dados do local de supressão</h5>
              <div className='col-md-12 col-lg-6 mb-2'>
                <span className="fw-bold">Tipo de compensação: </span> {requerimento?.tipoCompensacao ? requerimento?.tipoCompensacao : "Não informado"}
              </div>
              <div className='col-md-2 col-lg-6 mb-2'>
                <span className="fw-bold">Número do processo: </span> {requerimento?.numeroProcesso ? requerimento?.numeroProcesso : "Não informado"}
              </div>
              <div className='col-md-12 col-lg-12 mb-2'>
                <span className="fw-bold">Motivo da solicitação: </span> {requerimento?.motivoSolicitacao ?? ""}
              </div>
              <div className='col-md-12 col-lg-12 mb-2'>
                <span className="fw-bold">Endereço: </span> {requerimento?.logradouro ?? ""}, {requerimento?.numero ?? ""}, {requerimento?.complemento ? requerimento?.complemento + ", " : ""}{requerimento?.bairro ?? ""}, {requerimento?.cidade ?? ""}, {requerimento?.cep ?? ""}, {requerimento?.uf ?? ""}
              </div>
            </div>
            <div className='row pb-2 shadowFicha rounded-1 mb-4'>
              <h5 className='py-2 titleFicha'>Documentos anexados</h5>
              <div className='py-2 d-flex align-items-start justify-content-center gap-3 flex-wrap'>
                {requerimento.requerimentoDocumentos_Ids && requerimento.requerimentoDocumentos_Ids.length > 0 && requerimento.requerimentoDocumentos_Ids.map((value, index) => (
                  <Button
                    key={index}
                    outline
                    color='secondary'
                    onClick={() => handleDownloadFile(requerimentoFicha ? value.arquivo.split("data:application/pdf;base64,")[1] : value.base64, value.identificacaoDocumento)}
                  >
                    <FontAwesomeIcon icon={faFileDownload} />
                    <span className="ms-2">{value.identificacaoDocumento}</span>
                  </Button>
                ))}
              </div>
            </div>
            <div className='row pb-4 shadowFicha historico rounded-1 '>
              <h5 className='py-2 titleFicha'>Histórico dos eventos</h5>
              {requerimento.etapaAtual && requerimento.requerimentoAcos &&
                <div className='row'>
                  <div className='col-md-1 d-flex align-items-start justify-content-end '>
                    <div className='bg-secondary h-100 d-lg-block d-md-none' style={{ width: "3px" }}>

                    </div>
                  </div>
                  <div className='col-md-12 col-lg-11 pb-4'>
                    <AcaoAtual
                      requerimento={requerimento}
                      editavel={editavel}
                      loadRequerimento={loadRequerimento}
                      setDocumento={setDocumento}
                      setDocumentos={setDocumentos}
                      documentos={documentos}
                    />
                    <AcoesRealizadas
                      showDivs={showDivs}
                      requerimento={requerimento}
                      editavel={editavel}
                      loadRequerimento={loadRequerimento}
                    />
                    <div>
                      <AcoesAnexos requerimento={requerimento} />
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </MainCard>
    </>
  )
}

export default FichaRequerimento;